module.exports = __webpack_public_path__ + "img/safeguard.bbbd8d8b.svg";